import React from 'react';
import css from './Section.module.css';
import howItWorksImage1 from '../assets/howItWorks1.jpeg';
import howItWorksImage2 from '../assets/howitWorks2.jpeg';
import howItWorksImage3 from '../assets/howitWorks3.jpeg';

function SectionMadeItEasy(props) {
  const { intl } = props;
  const data = [
    {
      img: howItWorksImage1,
      titleId: 'SectionMadeItEasy.step1.title',
      descriptionId: 'SectionMadeItEasy.step1.description',
    },
    {
      img: howItWorksImage2,
      titleId: 'SectionMadeItEasy.step2.title',
      descriptionId: 'SectionMadeItEasy.step2.description',
    },
    {
      img: howItWorksImage3,
      titleId: 'SectionMadeItEasy.step3.title',
      descriptionId: 'SectionMadeItEasy.step3.description',
    },
  ];
  return (
    <div className={css.howItWorkSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <h2>{intl.formatMessage({ id: 'SectionMadeItEasy.title' })}</h2>
        </div>

        <div className={css.howItWorkContent}>
          {data.map((dataItem, index) => (
            <div className={css.moreInfoBlock} key={index}>
              <div className={css.infoImg}>
                <span className={css.count}>{index + 1}</span>
                <img src={dataItem.img} alt={intl.formatMessage({ id: dataItem.titleId })} />
              </div>
              <h4>{intl.formatMessage({ id: dataItem.titleId })}</h4>
              <p>{intl.formatMessage({ id: dataItem.descriptionId })}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SectionMadeItEasy;